import { memo } from 'react';
import { parseMarkdownToTextParagraphs } from './utils/text';

const Markdown = (props: { content: string; className?: string }) => {
  const paragraphs = parseMarkdownToTextParagraphs(props.content ?? '');
  return (
    <div className={props.className ?? ''}>
      {paragraphs.map((para, index) => (
        <p key={index}>
          {para.content.map((item, idx) => {
            if (item.link) {
              return (
                <a key={idx} href={item.link} target="_blank" rel="noopener noreferrer">
                  {item.text}
                </a>
              );
            }
            return (
              <span key={idx} data-bold={item.bold} data-italic={item.italic} data-code={item.code}>
                {item.text}
              </span>
            );
          })}
        </p>
      ))}
    </div>
  );
};

const MemoizedMarkdown = memo(Markdown);

export { MemoizedMarkdown as Markdown };
